var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGeschenkideen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-geschenkideen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18404",
    "data-name": "Rectangle 18404",
    width: 22.438,
    height: 24.957
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39702",
    "data-name": "Path 39702",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39704",
    "data-name": "Path 39704",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71360",
    "data-name": "Group 71360",
    transform: "translate(14.83 14.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71321",
    "data-name": "Group 71321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35702",
    "data-name": "Path 35702",
    d: "M2.761,4.963a4.027,4.027,0,0,1-.146-2.43A3.411,3.411,0,0,1,5.778.023,22.028,22.028,0,0,1,8.236.086,4.449,4.449,0,0,1,11,1.473c.065.066.135.128.223.212A4.445,4.445,0,0,1,13.129.367,7.465,7.465,0,0,1,14.721.034,16.489,16.489,0,0,1,16.584.018,3.439,3.439,0,0,1,19.9,4.025c-.051.307-.127.611-.186.891a6.871,6.871,0,0,1,1.266.32,2.376,2.376,0,0,1,1.451,2.285c.011,1.337.006,2.676-.023,4.013a2.906,2.906,0,0,1-.732,1.778,1.09,1.09,0,0,1-.921.434c-2.622-.021-5.245-.011-7.867-.011h-.4V7.507H9.966v6.228H9.554c-2.612,0-5.224-.014-7.836.012A1.2,1.2,0,0,1,.664,13.2,3.136,3.136,0,0,1,0,11.292C0,9.944-.012,8.6.031,7.248a2.421,2.421,0,0,1,2.163-2.23c.176-.016.352-.035.567-.056m7.171.02A2.4,2.4,0,0,0,8.367,2.675a6.488,6.488,0,0,0-2.658-.129.8.8,0,0,0-.688.694A1.453,1.453,0,0,0,6.288,4.951c.577.041,1.157.027,1.737.031.63,0,1.26,0,1.908,0m2.56-.018c1.2,0,2.374.024,3.549-.009a1.431,1.431,0,0,0,1.387-1.273A.958.958,0,0,0,16.484,2.5a18.267,18.267,0,0,0-1.955.052,2.421,2.421,0,0,0-2.037,2.409",
    transform: "translate(0 0)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35703",
    "data-name": "Path 35703",
    d: "M98.644,128.124h8.686c.006.121.017.231.017.342q0,2.306,0,4.612a3.729,3.729,0,0,1-3.759,3.761H98.644Z",
    transform: "translate(-86.15 -111.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35704",
    "data-name": "Path 35704",
    d: "M18.4,136.873h-.325c-1.517,0-3.035-.029-4.551.007A3.773,3.773,0,0,1,9.7,133.035c.014-1.507,0-3.014,0-4.521v-.358h8.7Z",
    transform: "translate(-8.468 -111.924)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGeschenkideen);
export default __webpack_public_path__ + "static/media/ic-geschenkideen.0e19382cc01a72b02bc03e9de761c42b.svg";
export { ForwardRef as ReactComponent };